import React, { useState, useEffect, Fragment } from 'react';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import Switch from 'react-switch';
import { uploadMutation } from '../queries/queries';
import passwordeye from '../img/eye-solid.svg';
import FieldWrapper from './FieldWrapper';

const { REACT_APP_IMAGE_BASE_URL, REACT_APP_BASE_URL, REACT_APP_BRAND } = process.env;
function Form(props) {
  const { children, sContent, get, parent, add, update, _id, onComplete, invitation, invitationAdminEmails } = props;

  const [addMutation, { loading: loadingAdd, error: errorAdd }] = useMutation(add);
  const [updateMutation, { loading: loadingUpdate, error: errorUpdate }] = useMutation(update);

  function submit(e) {
    e.preventDefault();
    const opts = {
      variables: sContent,
      refetchQueries: get && [{ query: get, variables: { [parent]: sContent[parent] } }],
    };
    if (sContent._id) {
      updateMutation(opts)
        .then(result => {
          // Om förening ändrats och inbjudna e-postadresser är ifyllt
          if (result.data.updateAssociation !== undefined && invitationAdminEmails?.invitationEmails?.length > 0) {
            invitationAdminEmails.invitationEmails.forEach(email => {
              invitation({
                variables: {
                  email: email,
                  associationId: result.data.updateAssociation._id,
                  portalUrlForEmails: `${REACT_APP_BASE_URL}/`
                }
              })
            })
          }
          onComplete(result);
        })
        .catch(useMutationError => { console.log('fromUpdateError', useMutationError, useMutationError && useMutationError.graphQLErrors) });
    } else {
      // delete opts.variables.adminEmails
      addMutation(opts)
        .then(result => {
          // Om förening lagts till och inbjudna e-postadresser är ifyllt
          if (result.data.createAssociation !== undefined && invitationAdminEmails?.invitationEmails?.length > 0) {
            invitationAdminEmails.invitationEmails.forEach(email => {
              invitation({
                variables: {
                  email: email,
                  associationId: result.data.createAssociation._id,
                  portalUrlForEmails: `${REACT_APP_BASE_URL}/`
                }
              })
            })
          }
          onComplete(result);
        })
        .catch(useMutationError => { console.log('formAddError', useMutationError, useMutationError && useMutationError.graphQLErrors) });
    }
  }
  // console.log('loadingAdd', loadingAdd);
  // console.log('loadingUpdate', loadingUpdate);

  return (
    <form onSubmit={(e) => submit(e)}>
      <div className="form-content">
        {children}
        {errorAdd && errorAdd.graphQLErrors.map(({ message }, i) => (
          <p className="error form" key={`addError${i}`}>{message}</p>
        ))}
        {errorUpdate && errorUpdate.graphQLErrors.map(({ message }, i) => (
          <p className="error form" key={`updateError${i}`}>{message}</p>
        ))}
      </div>
      <div className="form-buttons">
        <button type="button" className="secondary" onClick={() => props.onComplete()}>Avbryt</button>
        <button type="submit" className="primary">{(sContent && sContent._id) ? 'Spara' : 'Lägg till'}</button>
      </div>
    </form>
  );
}

Form.propTypes = {
  children: PropTypes.any.isRequired,
  sContent: PropTypes.object,
  get: PropTypes.object,
  parent: PropTypes.string,
  add: PropTypes.object.isRequired,
  update: PropTypes.object.isRequired,
  onComplete: PropTypes.func.isRequired,
};

Form.defaultProps = {
  sContent: null,
  get: null,
  parent: null,
};

function Group(props) {
  const { children, title, style } = props;
  return (
    <fieldset className="field-group" style={style}>
      <legend className="group-title">{title}</legend>
      {children}
    </fieldset>
  );
}

Group.propTypes = {
  children: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  style: PropTypes.object,
};


function Field(props) {
  const { name, type, x2, req, title, placeholder, value, onChange, disableWhenEmpty, selectDataInfo, isDataLoading, selectData, disabled, rows, allowZero, className, menuPlacement } = props;
  const [upload, { data: uploadData }] = useMutation(uploadMutation);
  const [inputVal, setInputVal] = useState();
  const [isPasswordShow, setIsPasswordShow] = useState(false)

  useEffect(() => {
    //        if (uploadData) uploadData.part_url = 'test/test.jpg';
    if (uploadData && uploadData.singleFileUpload && uploadData.singleFileUpload.partURL) setParentState(uploadData.singleFileUpload.partURL);
  }, [uploadData]);

  function setParentState(v) {
    if (type === 'number') {
      // Handle empty string or null/undefined as null
      if (v === '' || v === null || v === undefined) {
        onChange({ [name]: null });
      } else {
        onChange({ [name]: parseInt(v, 10) });
      }
    }
    else if (type === 'select') {
      onChange({ [name]: parseInt(v, 10) });
    }
    else {
      onChange({ [name]: v });
    }
  }

  function setParentStateSelect(v) {
    setParentState(v.value);
  }

  function setParentStateMultiSelect(selectedValues) {
    const values = [];
    if (selectedValues) {
      selectedValues.map((v) => {
        values.push(v.value);
        return null;
      });
    }
    setParentState(values);
  }


  const values = [];
  let selected = null;
  const components = {
    DropdownIndicator: null,
  };

  switch (type) {
    case 'select':
    case 'selectYesOrNo':
    case 'selectObject':
      if (selectDataInfo && selectData && !isDataLoading) {
        selectData.map((option) => {
          // console.log(option);
          // const val = returnSelectedObject ? option : id;
          const label = option.name ? option.name : `${option.firstname} ${option.lastname}`;
          values.push({ value: option._id, label });
          if (option._id === value) {
            selected = { value, label };
          }
          return null;
        });
      }

      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <Select
            className={`${name} ${x2 && 'x2'} ${className}`}
            options={values}
            value={selected}
            placeholder={placeholder}
            isLoading={isDataLoading}
            onChange={setParentStateSelect}
            isDisabled={disableWhenEmpty && values.length === 0}
            menuPlacement={menuPlacement}
          />
        </FieldWrapper>
      );

    case 'selectPeriod':
      if (selectDataInfo && selectData && !isDataLoading) {
        selectData.map((option) => {
          // const val = returnSelectedObject ? option : id;
          const date = new Date(option.startDate);
          const year = date.getFullYear();
          const label = `${year} - ${option.bookletTitle}`;
          values.push({ value: option.period, label });
          if (option.period === value) {
            selected = { value, label };
          }
          return null;
        });
      }

      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <Select
            className={`${name} ${x2 && 'x2'} ${className}`}
            options={values}
            value={selected}
            isLoading={isDataLoading}
            onChange={setParentStateSelect}
            isDisabled={disableWhenEmpty && values.length === 0}
          />
        </FieldWrapper>
      );

    case 'selectStatic':
      if (selectData) {
        selectData.map((option) => {
          values.push(option);
          if (option.value === value) {
            selected = option;
          }
          return null;
        });
      }

      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <Select
            className={`${name} ${x2 && 'x2'} ${className}`}
            options={values}
            value={selected}
            placeholder={placeholder}
            onChange={setParentStateSelect}
            isDisabled={disableWhenEmpty && values.length === 0}
            menuPlacement={menuPlacement}
          />
        </FieldWrapper>
      );

    case 'multiselect':
      if (selectData) {
        selectData.forEach((option) => {
          values.push(option);
        });

        const selectedValues = Array.isArray(value) ? value : [];
        selected = values.filter(option => selectedValues.includes(option.value));
      }

      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <Select
            className={`${name} ${x2 && 'x2'} ${className}`}
            options={values}
            value={selected}
            placeholder={placeholder}
            onChange={setParentStateMultiSelect}
            isMulti
            isDisabled={disabled || (disableWhenEmpty && values.length === 0)}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            required={req}
          />
        </FieldWrapper>
      );

    case 'admins':
      function handleChange(v, actionMeta) {
        setParentStateMultiSelect(v);
      }

      function handleKeyDown(event) {
        if (!inputVal) return;
        switch (event.key) {
          case 'Enter':
          case 'Tab':
            event.preventDefault();
            setInputVal('');
            if (value?.invitationEmails) {
              setParentState(value.invitationEmails ? [...value.invitationEmails, inputVal] : [inputVal]);
            } else {
              setParentState(value ? [...value, inputVal] : [inputVal]);
            }

        }
      }

      if (value) {
        if (value?.invitationEmails) {
          value?.invitationEmails?.map((option) => {
            values.push({ value: option, label: option });
            return null;
          });
        } else {
          value.map((option) => {
            values.push({ value: option, label: option });
            return null;
          });
        }
      }

      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <CreatableSelect
            components={components}
            className={`${name} ${className}`}
            inputValue={inputVal}
            options={values}
            defaultValue={values}
            isMulti
            isDisabled={disabled}
            menuIsOpen={false}
            onChange={handleChange}
            onInputChange={setInputVal}
            onKeyDown={handleKeyDown}
            placeholder={placeholder || 'Ange en e-postadress och tryck enter'}
            value={values}
            styles={{
              control: (base) => ({
                ...base,
                cursor: 'text'
              }),
              indicatorsContainer: (base) => ({
                ...base,
                cursor: 'pointer'
              }),
              multiValueLabel: (base) => ({
                ...base,
                cursor: 'default'
              }),
              multiValueRemove: (base) => ({
                ...base,
                cursor: 'pointer'
              })
            }}
          />
        </FieldWrapper>
      );

    case 'color':
      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="color"
              value={value || '#000000'}
              onChange={(e) => setParentState(e.target.value)}
              disabled={disabled}
              style={{ width: '40px', height: '32px', padding: '2px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '4px' }}
            />
            <input
              type="text"
              value={value || ''}
              onChange={(e) => setParentState(e.target.value)}
              disabled={disabled}
              placeholder="#000000"
              style={{ flex: 1 }}
            />
          </div>
        </FieldWrapper>
      );

    case 'image':

      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <div className="image-upload-container">
            {value && (
              <button
                type="button"
                className="delete-image-btn"
                onClick={() => {
                  // set image state to null
                  setParentState(null);
                }}
              >
                ×
              </button>
            )}
            <div alt="image" style={(value && { backgroundImage: `url(${REACT_APP_IMAGE_BASE_URL}${value})` })} />
            <input
              style={{ position: 'relative' }}
              type="file"
              onChange={(event) => {
                const [file] = event.target.files;
                const fileSize = file.size;
                const maxSize = 1000000;
                console.log('file: ', file);
                if (fileSize > maxSize) {
                  alert('Filen är för stor. Max 1MB');
                  return;
                }
                upload({
                  variables: { file, folder: 'company' },
                });
              }}
            />
          </div>
        </FieldWrapper>
      );

    case 'textarea':
      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <textarea
            className={`${name} ${x2 && 'x2'} ${className}`}
            value={value ? value : ''}
            onChange={(e) => setParentState(e.target.value)}
            placeholder={placeholder}
            disabled={disabled && true}
            style={{ resize: 'vertical' }}
            rows={rows || 4}
          />
        </FieldWrapper>
      );

    case 'switch':
      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          <Switch
            onChange={(checked) => setParentState(checked)}
            checked={value || false}
            disabled={disabled}
            onColor={REACT_APP_BRAND === 'CITY' ? '#222' : '#82C8C8'}
            onHandleColor='#fff'
            handleDiameter={20}
            uncheckedIcon={<small className="react-switch-icon off">Av</small>}
            checkedIcon={<small className="react-switch-icon on">På</small>}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={24}
            width={48}
            className={`react-switch ${className}`}
          />
        </FieldWrapper>
      );

    default:
      return (
        <FieldWrapper name={name} title={title} x2={x2}>
          {type !== 'password'
            ? <input
              type={type}
              value={allowZero ? (value !== null && value !== undefined ? value : '') : (value ? value : '')}
              onChange={(e) => setParentState(e.target.value)}
              disabled={disabled && true}
              onWheel={(e) => type === 'number' && e.target.blur()}
              required={req}
            />
            : <Fragment>
              <input type={isPasswordShow ? 'text' : 'password'} value={value ? value : ''} onChange={(e) => setParentState(e.target.value)} />
              {type === 'password' && <div className={`password-icon  ${isPasswordShow && 'showed'}`} onClick={() => setIsPasswordShow(!isPasswordShow)}><img src={passwordeye} className={`show-password`} /></div>}
            </Fragment>
          }

        </FieldWrapper>
      );
  }
}


Field.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  selectData: PropTypes.array,
  selectDataInfo: PropTypes.object,
  isDataLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  x2: PropTypes.bool,
  req: PropTypes.bool,
  disableWhenEmpty: PropTypes.bool,
  disabled: PropTypes.bool,
  allowZero: PropTypes.bool,
  className: PropTypes.string,
  menuPlacement: PropTypes.string,
};

Field.defaultProps = {
  x2: false,
  req: false,
  disableWhenEmpty: false,
  value: null,
  placeholder: null,
  selectData: null,
  selectDataInfo: null,
  isDataLoading: false,
  allowZero: false,
};

function Button(props) {
  const { children, className, loading, disabled, type, onClick, title } = props;



  return (
    <button className={`${className} ${loading && 'loading'}`} disabled={disabled} type={type} onClick={onClick} title={title}>
      <span>{children}</span>
      {loading &&
        <div className="bouncing-container">
          <div className="element-animation one"></div>
          <div className="element-animation two"></div>
          <div className="element-animation three"></div>
        </div>
      }
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
};

Button.defaultProps = {
  loading: false,
  disabled: false,
  className: '',
  type: 'button',
  onClick: null,
};

export { Form, Field, Group, Button };
